import { getImageUrl } from "src/Common/common";
import { Oval } from "react-loader-spinner";

const WhiteUploadButton = ({ clicked, isLoading }) => {
  return (
    <div
      onClick={isLoading ? undefined : clicked}
      className={`rounded-[6px] w-[100px] h-[30px] flex items-center justify-center gap-1 border-solid border-borderColor border-[1px] ${isLoading ? "cursor-not-allowed opacity-70" : "cursor-pointer"}`}
    >
      {isLoading ? (
        <Oval
          visible={true}
          height="16"
          width="16"
          color="#404A6E"
          strokeWidth={8}
          secondaryColor="#404A6E"
          ariaLabel="oval-loading"
          wrapperStyle={{}}
          wrapperClass=""
        />
      ) : (
        <>
          <img src={getImageUrl("/images/common/upload_black.png")} />
          <span className="font-OpenSansRegular font-[600] text-[10px] text-[#404A6E]">UPLOAD</span>
        </>
      )}

    </div>
  );
};

export default WhiteUploadButton;
